/* ==========================================================================
Renders:
This file handles logic that renders on the product-template.liquid.

Purpose: 
This file handles the logic of: 
    - product-tool-features.liquid

Features:
    - Adds a quantity button for only LED Strip products
    - 

Helpers created:
    - 

Note:
*Assumes user is not logged in.
- Renders at theme.liquid, Line 427

========================================================================== 

*/

function updatePage() {
    const variants = document.querySelectorAll('.variant-btn');
    const lengthQty = document.querySelector('.length-button'); // Length of product (for strips)
    const label = document.querySelector('.length-label'); //Label that instructs users what to do
    const addToList = document.querySelector('.add-to-project-list-btn');
    lengthQty.style.display = 'none';
    label.style.display = 'none';
    addToList.style.display = 'none';

    const isLedStrip = lengthQty.dataset.isLedStrip === 'true';

    if (isLedStrip && variants.length) {
    variants.forEach(element => {
        element.addEventListener("click", function(e) {
            label.style.display = 'block';
            lengthQty.style.display = 'flex';
            addToList.style.display = 'block';
            
            addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
            addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
        })
    });
    
    const decrementBtn = document.querySelectorAll('.length-decrement-btn');
    const incrementBtn = document.querySelectorAll('.length-increment-btn');
    const currentLengthCounter = document.querySelector('.product-length');
    
    decrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            const currentLength = parseInt(currentLengthCounter.innerText);
            if (currentLength > 1 ) {
                currentLengthCounter.innerText = currentLength - 1;
                addToList.dataset.selectedLength = parseInt(currentLengthCounter.innerText);
            }
        })
    });

    incrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            const currentLength = parseInt(currentLengthCounter.innerText);
            currentLengthCounter.innerText = currentLength + 1;
            addToList.dataset.selectedLength = parseInt(currentLengthCounter.innerText);
        })
    })
    } else if (isLedStrip){
        addToList.style.display = 'block';
        label.style.display = 'block';
        lengthQty.style.display = 'flex';

        const decrementBtn = document.querySelectorAll('.length-decrement-btn');
        const incrementBtn = document.querySelectorAll('.length-increment-btn');
        const currentLengthCounter = document.querySelector('.product-length');
    
        decrementBtn.forEach(element => {
            element.addEventListener("click", function(e) {
                const currentLength = parseInt(currentLengthCounter.innerText);
                if (currentLength > 1 ) {
                    currentLengthCounter.innerText = currentLength - 1;
                    addToList.dataset.selectedLength = parseInt(currentLengthCounter.innerText);
                }
            })
        });

        incrementBtn.forEach(element => {
            element.addEventListener("click", function(e) {
                const currentLength = parseInt(currentLengthCounter.innerText);
                currentLengthCounter.innerText = currentLength + 1;
                addToList.dataset.selectedLength = parseInt(currentLengthCounter.innerText);
            })
        })
    
    } else if (variants.length) {
        addToList.style.display = 'block';
        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
            })
        });
        
    } else {
        addToList.style.display = 'block';
        // Add an adjusted variants for each loop here - double check tmr
        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
            })
        });
    }
}

document.addEventListener("DOMContentLoaded", (event) => {
    updatePage();
});


{{ 'project-tool.js' | asset_url | script_tag }}
{{ 'theme.js' | asset_url | script_tag }}